export enum Award {
  HUGO, LOCUS, NEBULA
}

export enum Status {
  NEW, UPDATE, ERROR
}

export class Sync {
  book: Book;
  status: Status;
}

export class AwardWin {
  year: number;
  award: Award;
}

export class Book {
  id: number;
  wikidataId: string;
  title: string;
  author: string;
  awardWins: AwardWin[];
  isRead?: boolean;
}

export class AwardWinner extends AwardWin {
  bookId: string;
}
